import { DEFAULT_LOCALE, LOCALES, NAMESPACES as VERDI_COMMON_NAMESPACES } from "verdi-common/i18n";

// Source of truth for the dashboard's locale list lives in `verdi-common` (`LOCALES`),
// so any client (dashboard, backend, future apps) consumes the same set. `languages`
// re-shapes the list into the legacy `{ default, [code]: code }` map the dashboard's
// existing call sites already consume.
export const languages = LOCALES.reduce(
    (acc, code) => {
        acc[code] = code;
        return acc;
    },
    { default: DEFAULT_LOCALE },
);

// These are the names of the translation files to reference without the .json prefix
// we declare it as an object to make it easier to reference in the code
export const NAMESPACES = {
    COMMON: "common",
    COMPONENTS: "components",
    ICONS: "icons",
    FEATURES: {
        CARDS: "features/cards",
        DATA_VIEWER: "features/data-viewer",
        SCHEDULE_EDITOR: "features/schedule-editor",
        VERIFICATION: "features/verification",
        PRODUCT_UPDATE: "features/product-update",
        NAVIGATION: "features/navigation",
        SEARCH: "features/search",
        NOTIFICATION_SUBSCRIPTIONS: "features/notification-subscriptions",
    },
    PAGES: {
        MAP: "pages/map",
        ERROR_PAGE_NOT_FOUND: "pages/error-page-not-found",
        ERROR_PAGE_RECOVERY: "pages/error-page-recovery",
        SETTINGS: "pages/settings",
    },
    // Re-export verdi-common-owned namespaces so dashboard call sites can keep
    // using a single `NAMESPACES` object.
    WARNINGS: VERDI_COMMON_NAMESPACES.WARNINGS,
    TIMEZONES: VERDI_COMMON_NAMESPACES.TIMEZONES,
};

// Namespaces verdi-common mounts itself, via registerWarningsTranslations(i18n) and
// registerTimezonesTranslations(i18n). They have no locale file on disk.
const VERDI_COMMON_NAMESPACE_VALUES = Object.values(VERDI_COMMON_NAMESPACES);

// flatten the namespace values into a single array, needed for i18n config
const flattenNamespaceValues = (obj) =>
    Object.values(obj).flatMap((value) => (typeof value === "string" ? value : flattenNamespaceValues(value)));

// Namespaces backed by dashboard locale files on disk, so verdi-common-owned ones are
// intentionally excluded — listing them here would make i18next try to fetch a file that
// does not exist and overwrite the mounted bundle with the fallback namespace.
export const translationPaths = flattenNamespaceValues(NAMESPACES).filter(
    (path) => !VERDI_COMMON_NAMESPACE_VALUES.includes(path),
);
